import _ from "lodash";
import React, { useEffect, useRef } from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import classes from "./Note.scss";
import TextAreaInput from "UIComponents/TextAreaInput";
import PropTypes from "prop-types";
import { colors } from "Constants/colorConstants";
import { AiOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";

import { isNewNotesUi } from "Post/utils";

const Note = props => {
  const {
    updateNote,
    value,
    noteTextAreaStyles,
    minRows,
    noteName,
    placeholder,
    onBlur,
    linesContainerStyles,
    autoFocus,
    isFocused,
    testId,
    showAIIcon = false,
    onAIIconClick = _.noop,
  } = props;

  const isNewNoteUi = isNewNotesUi();

  const aiButtonStyle = {
    display: "flex",
    borderRadius: "4px",
    background: colors.white,
    boxShadow: "0px 2px 4px 0px rgba(0, 46, 57, 0.15)",
    marginTop: "16px",
    marginRight: "12px",
  };

  const textAreaInputRef = useRef();

  useEffect(() => {
    if (isFocused && textAreaInputRef?.current) {
      textAreaInputRef.current.focus();
    }
  }, []);

  return (
    <div
      className={
        isNewNoteUi ? classes.noteLinesContainerV2 : classes.noteLinesContainer
      }
      style={linesContainerStyles}
    >
      <div
        className={
          isNewNoteUi ? classes.noteContainerV2 : classes.noteContainer
        }
      >
        <TextAreaInput
          ref={textAreaInputRef}
          name={noteName}
          value={value}
          minRows={minRows}
          placeholder={placeholder}
          updateInputField={updateNote}
          textAreaStyles={noteTextAreaStyles}
          onBlur={onBlur}
          autoFocus={autoFocus}
          testId={testId}
        />
        {showAIIcon ? (
          <div className={classes.promptBoxContainer} style={aiButtonStyle}>
            <IconButton
              size={"small"}
              variant={"plain-subtle"}
              icon={<AiOutlined size="small" />}
              shouldStopPropagation
              onClick={onAIIconClick}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

Note.defaultProps = {
  ...UIBaseComponent.defaultProps,
  noteTextAreaStyles: {},
  minRows: 10,
  noteName: "Title",
  linesContainerStyles: {},
  autoFocus: false,
  isFocused: false,
};

Note.propTypes = {
  ...UIBaseComponent.propTypes,
  minRows: PropTypes.number,
  noteTextAreaStyles: PropTypes.object,
  linesContainerStyles: PropTypes.object,
  updateNote: PropTypes.func,
  noteName: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
  isFocused: PropTypes.bool,
};

export default Note;
